<template>
  <div class="index">
    <!-- head -->
    <div class="head">
      <img src="../../static/images/banner.png" alt="img" class="headImg">
      <div class="headC">
        <div class="headCnav">
          <a href="#" class="headCnavLogo">
            <img src="../../static/images/yinxianghua.png" alt="img" />
          </a>
          <ul class="headCnavS">
            <li>
              <a href="javascript:;">首页</a>
            </li>
            <li>
              <a href="javascript:;" @click="goRule('plan')">产品与服务</a>
            </li>
            <li>
              <a href="javascript:;" @click="goRule('ability')">产品功能</a>
            </li>
            <li>
              <a href="javascript:;" @click="goRule('advantage')">产品优势</a>
            </li>
            <div class="clear"></div>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="headCE">
          <h4>盈享花</h4>
          <p>
            专注于前沿技术的应用创新，赋能金融机构全链路业务流程的智能分析与运营、精准营销以及运营管理，形成本地化部署、云端创新产品集成的数智化闭环解决方案。打造定制化、集成化的业务服务体系，灵活适配贷前管理、贷中管理、贷后管理、场景化营销等各场景，为金融机构提供覆盖业务全流程的智能管理工具和敏捷服务。
          </p>
        </div>
      </div>
    </div>
    <!-- plan -->
    <div class="plan" id="plan">
      <!-- Htit -->
      <div class="Htit">
        <h4>不同行业的解决方案，精准控制风险</h4>
        <p>基于内部生产实践，快速响应业务需求</p>
      </div>
      <ul class="planC">
        <li>
          <img src="../../static/images/plan1.png" alt="img" class="planCimg">
          <div class="planCE">
            <h4>产品赋能</h4>
            <p>使用联合运营的方式，对接多家流量机构，并在全流程使用布尔的专业风控能力，帮助银行解决贷前、贷中、贷后各个阶段的风险难题。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/plan2.png" alt="img" class="planCimg">
          <div class="planCE">
            <h4>丰富租贷经验</h4>
            <p>拥有丰富的租赁行业经验，完善的租赁行业模型和策略，有效防范各种欺诈行为，提升平台风控能力，助力构建绿色经济生态系统。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/plan3.png" alt="img" class="planCimg">
          <div class="planCE">
            <h4>产品输出</h4>
            <p>借助互联网技术、大数据、金融科技，通过全线上化的、开放的、智能化的产品和服务切入场景，有效解决金融机构获客、风险控制、贷后系列问题。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/plan4.png" alt="img" class="planCimg">
          <div class="planCE">
            <h4>优化迭代</h4>
            <p>及时收集客户反馈，对产品及服务进行升级优化，始终保持产品的精准度、有效性。</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- ability -->
    <div class="ability" id="ability">
      <!-- Htit -->
      <div class="Htit Htit1">
        <h4>产品的功能</h4>
        <p>助力高效，保障核心生产力</p>
      </div>
      <ul class="abilityC">
        <li>
          <img src="../../static/images/ability1.png" alt="img" class="abilityCimg">
          <div class="abilityCE">
            <h4>前沿技术</h4>
            <p>备创新性和前瞻性的技术研究与技术应用探索，助力实现金融场景下服务方式和工具的升华；助力合作机构在提高效率、降低运营成本、提升客户体验。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/ability2.png" alt="img" class="abilityCimg">
          <div class="abilityCE">
            <h4>数智化产品</h4>
            <p>赋能金融机构全链路业务流程的智能分析与运营、精准营销以及运营管理，形成本地化部署、云端创新产品集成的数智化闭环解决方案。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/ability3.png" alt="img" class="abilityCimg">
          <div class="abilityCE">
            <h4>科技赋能</h4>
            <p>为金融机构合作伙伴提供高适配性、高稳定性的产品及解决方案。并基于行业理解和客户洞察，提供涵盖智能分析与运营、精准营销、保险营销的全流程数智化服务。</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- advantage -->
    <div class="advantage" id="advantage">
      <!-- Htit -->
      <div class="Htit">
        <h4>产品优势</h4>
      </div>
      <ul class="advantageC">
        <li>
          <img src="../../static/images/advantage1.png" alt="img" class="advantageCimg">
          <div class="advantageCE">
            <h4>能力衍生</h4>
            <p>结合大数据和机器学习技术，持续推动产品创新来完善产品体系、为消费分期市场提供更多智能风控能力，提升金融机构风控效率。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/advantage2.png" alt="img" class="advantageCimg">
          <div class="advantageCE">
            <h4>产品输出</h4>
            <p>快速判断潜在客户的违约风险，避免无谓的获客成本开支，使得机构能够结合风险偏好、通过率等业务指标，制定有效的准入策略。</p>
          </div>
        </li>
        <li>
          <img src="../../static/images/advantage3.png" alt="img" class="advantageCimg">
          <div class="advantageCE">
            <h4>场景切入</h4>
            <p>普信决策智能体系的核心产品，提供超高并发量的数据处理，限时免费开放，携手客户搭建标准化指标体系，满足金融、支付、保险等场景应用。</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- cooperate 252 110-->
    <div class="cooperate" id="cooperate">
      <!-- Htit -->
      <div class="Htit">
        <h4>合作伙伴</h4>
      </div>
      <div class="cooperateCon">
        <ul class="cooperateC">
          <li v-for="(item, index) in cooperateList" :key="index">
            <img :src="item.img" alt="img" class="cooperateCimg">
          </li>
        </ul>
      </div>
    </div>
    <!-- register -->
    <div class="register">
      <p>立即注册，开启普信决策智能服务</p>
      <a href="javascript:;" @click="registerPUPshow">
        申请使用
        <img src="../../static/images/right.png" alt="img">
      </a>
    </div>
    <!-- footer -->
    <div class="footer">
      <div class="footerT">
        <div class="footerTL">
          <div class="footerTLtit">
            <h4>服务与支持</h4>
            <p></p>
          </div>
          <div class="footerTLB">
            <p>服务电话: 4009978318</p>
            <!-- <p>商务合作: ahuishilei@163.com</p>
            <p>服务支持: ahuishilei@163.com</p> -->
            <p>工作时间: 9:00-18:00 (工作日)</p>
            <a href="javascript:void(0)" @click="goToBeianNumber">皖ICP备2023014689号-1</a>
            <!-- <p>公司地址: 安徽省合肥市华邦世贸城A座31楼</p> -->
          </div>
        </div>
        <!-- <div class="footerTR">
          <div class="footerTLtit">
            <h4>关注我们</h4>
            <p></p>
          </div>
          <div class="footerTRC">
            <div class="footerTRCI">
              <img src="../../static/images/code.png" alt="img">
              <p>微信二维码</p>
            </div>
            <div class="footerTRCI">
              <img src="../../static/images/code.png" alt="img">
              <p>微信二维码</p>
            </div>
            <div class="clear"></div>
          </div>
        </div> -->
      </div>
      <!-- <div class="footerB">
        <a href="#">中国银联</a>
        <em>|</em>
        <a href="#">大搜车</a>
        <em>|</em>
        <a href="#">太平洋保险</a>
        <em>|</em>
        <a href="#">人人租机</a>
        <em>|</em>
        <a href="#">安恒信息蚂蚁集团</a>
        <em>|</em>
        <a href="#">百度</a>
        <em>|</em>
        <a href="#">租物租</a>
      </div> -->
    </div>
    <!-- broadside -->
    <ul class="broadside">
      <li>
        <a href="javascript:;" :class="{ on: broadsideOn == 'plan' }" @click="goRule('plan')">
          <img src="../../static/images/broadside1.png" alt="img" class="broadsideImg1" />
          <img src="../../static/images/broadside1i.png" alt="img" class="broadsideImg2" />
          产品服务
        </a>
      </li>
      <li>
        <a href="javascript:;" :class="{ on: broadsideOn == 'ability' }" @click="goRule('ability')">
          <img src="../../static/images/broadside2.png" alt="img" class="broadsideImg1" />
          <img src="../../static/images/broadside2i.png" alt="img" class="broadsideImg2" />
          产品功能
        </a>
      </li>
      <li>
        <a href="javascript:;" :class="{ on: broadsideOn == 'cooperate' }" @click="goRule('cooperate')">
          <img src="../../static/images/broadside3.png" alt="img" class="broadsideImg1" />
          <img src="../../static/images/broadside3i.png" alt="img" class="broadsideImg2" />
          合作伙伴
        </a>
      </li>
    </ul>
    <!-- 申请使用弹窗 -->
    <div class="registerPUP" v-if="registerPUPis">
      <div class="registerPUPbg" @click="registerPUPhide"></div>
      <div class="registerPUPC">
        <h4 class="registerPUPCtit">申请使用</h4>
        <input type="text" placeholder="请输入手机号" class="registerPUPCinput" />
        <input type="text" placeholder="请输入姓名" class="registerPUPCinput" />
        <button class="registerPUPCbtn">立即提交</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      broadsideOn: 'plan',
      registerPUPis: false,
      cooperateList: [{
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5NOASdssAABgQFbSHx8705.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5OCABeyGAAAuvz0ZxzQ181.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5OmAcn_JAAA9g0NM8zo131.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5PWAf1stAABLjLevY8Q764.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5QCAObAHAAAyeCoeeoo683.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5QeAFJsUAAAvgvE9tHo339.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5RGADiHEAAA5LupnFjc480.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5RmAYN-9AAA1JgjOs_8822.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5SOANhilAAAwAAJdjEU911.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5SyAeoYyAAA72zxSEHE055.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5TWAZ_-MAAA5cz1b4dM369.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5T2AW5QTAAAwAk1LAUs154.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5UWAE2tMAAAuzyJiq7o579.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5U-AftN0AAA4I6euTHM788.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5VmAM1-xAAAke8pVg1k913.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5WGAUpXeAABO5M7iSaA096.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5WmAFJhNAAA2PRTZSbk038.png'
      }, {
        'img': 'https://www.shileizuji.com/group1/M00/08/61/rBYIvWSb5XGAHXiMAAAvD_DYbog005.png'
      }],

    };
  },
  mounted() {

  },
  methods: {
    //导航
    goRule(event) {
      this.broadsideOn = event;
      var id = "#" + event;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    //申请使用弹窗
    registerPUPshow() {
      this.registerPUPis = true;
    },
    registerPUPhide() {
      this.registerPUPis = false;
    },
    //goToBeianNumber
    goToBeianNumber() {
      // const beianNumber = '皖ICP备2023014689号-1';
      const workInfoUrl = 'https://beian.miit.gov.cn/#/Integrated/index';
      // window.location.href = workInfoUrl;
      window.open(workInfoUrl, '_blank');
    },

  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/index.vue